module.exports = __webpack_public_path__ + "assets/img/serial_com.df98e0c5.png";